// Minimal subset of the company-detail service, ported from
// feature/company-profile-v2 for the feature-flag admin panel. The full
// company-profile work carries the complete version of this file.
import axios from 'axios';

import getAuthSession from './auth';
import { CompanyReference } from '../interfaces/companyDetail.interface';

async function authHeaders(): Promise<{ Authorization: string }> {
  const authSession = await getAuthSession();
  return { Authorization: `Bearer ${authSession.getIdToken().getJwtToken()}` };
}

/**
 * Lightweight company identity records for a set of ids, scoped server-side to
 * companies the requester can access.
 */
export async function getCompanyReferences(ids: number[]): Promise<CompanyReference[]> {
  if (ids.length === 0) return [];
  const response = await axios.get<CompanyReference[]>(
    `${process.env.REACT_APP_BASE_API}/company-references/`,
    { headers: await authHeaders(), params: { ids: ids.join(',') } },
  );
  return response.data;
}
